import { render, staticRenderFns } from "./LicensDetail.vue?vue&type=template&id=06c49752"
import script from "./LicensDetail.vue?vue&type=script&lang=js"
export * from "./LicensDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports